import React from "react";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const services = [
  {
    title: "Résidentiel",
    desc: "Cuisines, dressings, salles de bain, mobilier sur mesure pour particuliers.",
    img: "/service-cuisine.jpg",
    span: "md:col-span-7",
    height: "h-[420px] md:h-[520px]",
    testid: "service-residentiel",
  },
  {
    title: "Dressing & Rangements",
    desc: "Optimisation d'espaces avec finitions premium et menuiserie soignée.",
    img: "/service-dressing.jpg",
    span: "md:col-span-5",
    height: "h-[420px] md:h-[520px]",
    testid: "service-dressing",
  },
  {
    title: "Commerces & Professionnels",
    desc: "Boutiques, pharmacies, cabinets, bureaux : comptoirs, vitrines et agencements pensés pour vendre et accueillir.",
    img: "/portfolio/commerces/commerce-1-librairie-reunion.jpg",
    span: "md:col-span-12",
    height: "h-[340px] md:h-[440px]",
    testid: "service-commerces",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-stone-50 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <p className="mb-4 text-xs uppercase tracking-[0.25em] text-orange-800">
              Mes services
            </p>
            <h2 className="text-3xl font-light leading-tight tracking-tight text-stone-900 sm:text-5xl">
              Tous types d'agencement, <span className="italic">une seule exigence&nbsp;: vous.</span>
            </h2>
          </div>
          <p className="max-w-md text-base text-stone-600">
            Du résidentiel haut de gamme à l'aménagement de votre commerce, je
            coordonne chaque étape avec des artisans-fabricants de confiance.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-12">
          {services.map((s) => (
            <a
              href="#devis"
              onClick={scrollToId("devis")}
              key={s.title}
              data-testid={s.testid}
              className={`group relative overflow-hidden rounded-2xl border border-stone-200 bg-white ${s.span} ${s.height} card-hover`}
            >
              <img
                src={s.img}
                alt={s.title}
                className="absolute inset-0 h-full w-full object-cover img-zoom"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/85 via-stone-900/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="text-2xl font-medium text-stone-50 sm:text-3xl">
                      {s.title}
                    </h3>
                    <p className="mt-2 max-w-sm text-sm text-stone-200/90">{s.desc}</p>
                  </div>
                  <div className="rounded-full border border-stone-50/30 bg-stone-50/10 p-3 text-stone-50 transition group-hover:bg-orange-700 group-hover:border-orange-700">
                    <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
